"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GodModePanel = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _shoppingContext = require("@ori/shopping-context");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _checkoutGodModeHeightContext = require("../../contexts/checkoutGodModeHeightContext");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _FormattedMessage = require("../FormattedMessage");
var _GodModeTable = require("../GodModeTable");
var _BarInfo = require("./components/BarInfo");
var _jsxRuntime = require("react/jsx-runtime");
const Wrapper = (0, _mui.styled)(_mui.Paper, {
    shouldForwardProp (propName) {
        return propName !== 'isFullWidth' && propName !== 'height';
    }
})((param)=>{
    let { isFullWidth, height } = param;
    return {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: isFullWidth ? 0 : 'auto',
        zIndex: 10,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        height: isFullWidth ? height : 'auto'
    };
});
const Placeholder = (0, _mui.styled)('div', {
    shouldForwardProp (propName) {
        return propName !== 'isFullWidth' && propName !== 'height';
    }
})((param)=>{
    let { isFullWidth, height } = param;
    return {
        display: isFullWidth ? 'block' : 'none',
        marginBottom: isFullWidth ? height : 0
    };
});
const Handler = (0, _mui.styled)('div', {
    shouldForwardProp (propName) {
        return propName !== 'isFullWidth';
    }
})((param)=>{
    let { isFullWidth } = param;
    return {
        display: isFullWidth ? 'block' : 'none',
        height: 5,
        cursor: 'row-resize'
    };
});
const BarBackground = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        background: theme.palette.secondary.light,
        color: theme.palette.text.primary,
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 2)
    };
});
const CLOSE_URL = '/backoffice/RuleTest/Exit';
const GodModePanel = exports.GodModePanel = /*#__PURE__*/ (0, _react.memo)(()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    const [isGodModeDisabled, setIsGodModeDisabled] = (0, _react.useState)(false);
    const [isCloseModalVisible, setIsCloseModalVisible] = (0, _react.useState)(false);
    const [height, startResizing] = (0, _hooks.useBarHeight)(_models.LocalStorageKey.Height);
    const { godModeVisible, toggleGodModeVisible } = (0, _checkoutGodModeHeightContext.useCheckoutGodModeHeight)();
    const close = (0, _react.useCallback)(async ()=>{
        setIsCloseModalVisible(false);
        await fetch(CLOSE_URL, {
            method: 'POST'
        });
        setIsGodModeDisabled(true);
        toggleGodModeVisible();
        window.close();
    }, [
        toggleGodModeVisible
    ]);
    const closeExitModal = (0, _react.useCallback)(()=>setIsCloseModalVisible(false), [
        setIsCloseModalVisible
    ]);
    const openExitModal = (0, _react.useCallback)(()=>setIsCloseModalVisible(true), [
        setIsCloseModalVisible
    ]);
    const { shoppingContext } = (0, _shoppingContext.useShoppingContext)();
    if (!(shoppingContext === null || shoppingContext === void 0 ? void 0 : shoppingContext.godModeOutput) || isGodModeDisabled) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Placeholder, {
                isFullWidth: godModeVisible,
                height: height
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.FeedbackDialog, {
                "data-testid": getTestId('close-dialog'),
                open: isCloseModalVisible,
                header: formatMessage(_models.TranslationKey.closeGodModeQuestion),
                "aria-label": formatMessage(_models.TranslationKey.closeGodModeQuestion),
                actions: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
                        fullWidth: true,
                        color: "primary",
                        variant: "contained",
                        id: "accept",
                        "data-testid": getTestId('close-dialog-confirm'),
                        onClick: close,
                        children: formatMessage(_models.TranslationKey.close)
                    }, "accept"),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
                        fullWidth: true,
                        variant: "text",
                        component: "button",
                        id: "reject",
                        "data-testid": getTestId('close-dialog-cancel'),
                        onClick: closeExitModal,
                        children: formatMessage(_models.TranslationKey.cancel)
                    }, "reject")
                ],
                onClose: closeExitModal,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                    "data-testid": getTestId('close-dialog-message'),
                    children: formatMessage(_models.TranslationKey.closeGodModeWindow)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Wrapper, {
                isFullWidth: godModeVisible,
                height: height,
                "data-testid": getTestId('bar'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Handler, {
                        isFullWidth: godModeVisible,
                        onMouseDown: startResizing
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(BarBackground, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                                variant: "h6",
                                style: {
                                    flexGrow: 2
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                                    id: _models.TranslationKey.godModeBarTitle
                                })
                            }),
                            godModeVisible ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_BarInfo.BarInfo, {}) : null,
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.IconButton, {
                                variant: "text",
                                color: "default",
                                size: "small",
                                onClick: toggleGodModeVisible,
                                children: godModeVisible ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.ArrowDownThin, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.ArrowUpThin, {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.IconButton, {
                                variant: "text",
                                color: "default",
                                size: "small",
                                onClick: openExitModal,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Clear, {})
                            })
                        ]
                    }),
                    godModeVisible ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_GodModeTable.GodModeTable, {}) : null
                ]
            })
        ]
    });
});
